import { render, staticRenderFns } from "./ExtendBookingView.vue?vue&type=template&id=67f1656c&scoped=true"
import script from "./ExtendBookingView.vue?vue&type=script&lang=js"
export * from "./ExtendBookingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f1656c",
  null
  
)

export default component.exports